import { render, staticRenderFns } from "./animation-firework.vue?vue&type=template&id=0f8e2294"
import script from "./animation-firework.vue?vue&type=script&lang=js"
export * from "./animation-firework.vue?vue&type=script&lang=js"
import style0 from "./animation-firework.vue?vue&type=style&index=0&id=0f8e2294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports